import React, { useState } from 'react';
import { useSiteNavigation } from '../hooks/useSiteNavigation';
import { useSubdomain } from '../contexts/SiteContext';
import './SiteSelector.css';

const SiteSelector = ({ showLabel = true, compact = false }) => {
  const { sites, activeSite, changeActiveSite, getCurrentSubdomain } = useSubdomain();
  const { isManager } = useSiteNavigation();
  const [isOpen, setIsOpen] = useState(false);

  // Si no es manager o no hay sites, no mostrar el selector
  if (!isManager || sites.length === 0) {
    return null;
  }

  // Si solo hay un site, deshabilitar el selector
  const isDisabled = sites.length === 1;

  const handleSiteChange = (siteId) => {
    const site = sites.find(s => s.id === siteId);
    if (site) {
      const currentSubdomain = getCurrentSubdomain();
      
      // Si hay discrepancia de subdomain, changeActiveSite manejará la redirección
      if (currentSubdomain !== 'default' && site.subdomain !== currentSubdomain) {
        console.log('🔄 Cambio de site con discrepancia de subdomain - delegando a changeActiveSite');
        changeActiveSite(site);
        return; // changeActiveSite hará window.location.href, así que salir aquí
      }
      
      // Si no hay discrepancia de subdomain, cambiar el site y recargar la página actual
      console.log('🔄 Cambio de site sin discrepancia de subdomain - recargando página actual');
      changeActiveSite(site);
      
      // Construir la URL actual con el nuevo siteId
      const currentPath = window.location.pathname;
      const currentSearch = window.location.search;
      const currentHash = window.location.hash;
      
      // Extraer la ruta base sin el siteId actual
      const pathWithoutSiteId = currentPath.replace(/^\/site\/[^/]+/, '');
      
      // Construir la nueva URL con el nuevo siteId
      const newPath = `/site/${siteId}${pathWithoutSiteId}`;
      const newUrl = `${newPath}${currentSearch}${currentHash}`;
      
      console.log('🔄 Recargando página para validación de subdomain:', newUrl);
      
      // Recargar la página con la nueva URL para ejecutar validaciones
      window.location.href = newUrl;
      setIsOpen(false);
    }
  };

  const toggleDropdown = () => {
    if (!isDisabled) {
      setIsOpen(!isOpen);
    }
  };

  const closeDropdown = () => {
    setIsOpen(false);
  };

  return (
    <div className={`site-selector ${compact ? 'compact' : ''}`}>
      {showLabel && <label className="site-selector-label">Centro de Entrenamiento:</label>}
      
      <div className="site-selector-dropdown">
        <button
          className={`site-selector-button ${isDisabled ? 'disabled' : ''}`}
          onClick={toggleDropdown}
          onBlur={closeDropdown}
          aria-haspopup="listbox"
          aria-expanded={isOpen}
          disabled={isDisabled}
        >
          <div className="site-selector-content">
            <span className="site-selector-icon">🏢</span>
            <span className="site-selector-text">
              {activeSite ? activeSite.name : 'Seleccionar centro'}
            </span>
            <span className="site-selector-arrow">
              {isOpen ? '▲' : '▼'}
            </span>
          </div>
        </button>
        
        {isOpen && (
          <div className="site-selector-menu">
            {sites.map((site) => (
              <button
                key={site.id}
                className={`site-selector-option ${
                  activeSite && activeSite.id === site.id ? 'active' : ''
                }`}
                onClick={() => handleSiteChange(site.id)}
              >
                <div className="site-option-content">
                  <span className="site-option-icon">🏢</span>
                  <div className="site-option-details">
                    <span className="site-option-name">{site.name}</span>
                    <span className="site-option-description">
                      {site.description || 'Sin descripción'}
                    </span>
                  </div>
                  {activeSite && activeSite.id === site.id && (
                    <span className="site-option-check">✓</span>
                  )}
                </div>
              </button>
            ))}
            
            {/* Opción para crear nuevo site */}
            <div className="site-selector-divider"></div>
            <button
              className="site-selector-option create-new"
              onClick={() => {
                setIsOpen(false);
                // Navegar a la página de creación de sites
                window.location.href = '/manager/sites/new';
              }}
            >
              <div className="site-option-content">
                <span className="site-option-icon">➕</span>
                <span className="site-option-name">Crear nuevo centro</span>
              </div>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SiteSelector;